// Maps a failed POST /v1/auth/portal/login to text a partner can act on.
// Each message only claims what the response actually proves.

export const LOGIN_ERROR_MESSAGES = {
  invalidCredentials: 'Incorrect email or password.',
  invalidRequest: 'Enter your email address and password.',
  forbidden: "This account can't sign in to the partner portal. Contact your administrator.",
  rateLimited: 'Too many sign-in attempts. Please wait a minute and try again.',
  unavailable: 'Sign in is unavailable right now. Please try again in a few minutes.',
  // No readable status: offline, DNS, timeout, or a response the browser
  // blocked (e.g. an error page without CORS headers). We can't tell which, so
  // don't blame the password or the service.
  unknown: "We couldn't complete sign in. Check your email, password and connection, then try again.",
};

export const loginErrorMessage = (error) => {
  const status = error?.response?.status;
  if (!status) return LOGIN_ERROR_MESSAGES.unknown;
  if (status === 401) return LOGIN_ERROR_MESSAGES.invalidCredentials;
  if (status === 400 || status === 422) return LOGIN_ERROR_MESSAGES.invalidRequest;
  if (status === 403) return LOGIN_ERROR_MESSAGES.forbidden;
  if (status === 429) return LOGIN_ERROR_MESSAGES.rateLimited;
  if (status >= 500) return LOGIN_ERROR_MESSAGES.unavailable;
  return LOGIN_ERROR_MESSAGES.unknown;
};
